var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.HighScoreHolder = function(stage, highscore) {
    var score = 0;
    var scoreContainer = new EHDI.aka.Container();
    stage.addChild(scoreContainer);
    var containerSprite = new EHDI.aka.Sprite(EHDI.Assets.images["gfx_container"]);
    
    scoreContainer.addChild(containerSprite);
    
    var scoreHeader = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_CONT_BEST"));

    scoreHeader.anchor.x = 0.5;
    scoreHeader.anchor.y = 0.5;
    scoreHeader.position.set(containerSprite.width * 0.169, containerSprite.height * 0.4);
    scoreContainer.addChild(scoreHeader);
    
    var scoreTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_CONT_BESTSCORE"));
    scoreTxt.text = "" + highscore;
    scoreTxt.anchor.x = 0.5;
    scoreTxt.anchor.y = 0.5;
    
    scoreTxt.position.set(containerSprite.width * 0.675, containerSprite.height * 0.45);
    scoreContainer.addChild(scoreTxt);
    
     var setDisplayPosition = function(x,y) {
        scoreContainer.position.set(x,y);
    }
    
    var dispose = function() {
        if(scoreHeader != null)
        {
            scoreContainer.removeChild(scoreHeader);
            scoreHeader.destroy({children: true});
        }
        delete scoreHeader;
        
        if(scoreTxt != null)
        {
            scoreContainer.removeChild(scoreTxt);
            scoreTxt.destroy({children: true});
        }
        delete scoreTxt;

        if(containerSprite != null)
        {
            scoreContainer.removeChild(containerSprite);
            containerSprite.destroy({children: true});
        }
        delete containerSprite;

        if(scoreContainer !=  null)
        {
            stage.removeChild(scoreContainer);
            scoreContainer.destroy({children: true});
        }

        if(onScoreTimeline != null) onScoreTimeline.kill();
        delete onScoreTimeline;
    };
    
    
    return {
        setXY : setDisplayPosition,
        dispose : dispose
    };
};